import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { alpha, useTheme } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { ButtonAnimate } from '../animate/others/ButtonAnimate';
export const MIconButton = forwardRef(({ color = 'default', children, sx, ...other }, ref) => {
    const theme = useTheme();
    if (color === 'default' || color === 'inherit' || color === 'primary' || color === 'secondary') {
        return (_jsx(ButtonAnimate, { children: _jsx(IconButton, Object.assign({ ref: ref, color: color, sx: sx }, other, { children: children }), void 0) }, void 0));
    }
    return (_jsx(ButtonAnimate, { children: _jsx(IconButton, Object.assign({ ref: ref, sx: {
                color: theme.palette[color].main,
                '&:hover': {
                    bgcolor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
                },
                ...sx,
            } }, other, { children: children }), void 0) }, void 0));
});
//# sourceMappingURL=MIconButton.js.map